import {Injectable} from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';

// JS-2084: superadmin-only pages. Mirrors the backend's AccessGuard::isRole('superadmin'),
// which is an exact-string match on user.role. The role string is written to localStorage
// at login (see completePostLogin in auth/models/post-login.ts); if an attacker tampers
// with it, the backend still rejects on its own isRole check — this guard is the frontend
// belt that keeps non-superadmin UIs (EasyTemp credentials, superadmin dashboard) from
// loading in the first place.
@Injectable()
export class SuperadminGuard implements CanActivate {

  constructor(private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (!currentUser || currentUser.role !== 'superadmin') {
      this.router.navigate(['/']);
      return false;
    }
    return true;
  }
}
